import { FormErrorMessage } from "@/shared/components";
import { cn } from "@/shared/utils";
import { Checkbox } from "./checkbox";
import { Helptext } from "./helptext";
import { Label } from "./label";

type CheckboxfieldProps = {
    label: string;
    checked: boolean;
    onCheckedChange: (checked: boolean) => void;
    disabled?: boolean;
    optional?: boolean;
    helptext?: string;
    id?: string;
    className?: string;
    labelClassName?: string;
    errorMessage?: string;
};

// simple checkboxfield, useful if a RHF checkboxfield is not necessary
export function Checkboxfield({
    label,
    labelClassName,
    checked,
    onCheckedChange,
    optional = false,
    helptext,
    disabled,
    id,
    className,
    errorMessage,
}: CheckboxfieldProps) {
    const checkboxId = id ?? label.toLowerCase().replace(/\s+/g, "-");

    return (
        <div className={cn("grid grid-cols-[auto_1fr] items-center gap-x-4.5", className)}>
            <Checkbox
                id={checkboxId}
                checked={checked}
                onCheckedChange={onCheckedChange}
                className="col-start-1"
                disabled={disabled}
                data-testid={`check-${checkboxId}`}
            />
            <Label
                htmlFor={checkboxId}
                optional={optional}
                className={cn("text-content-default col-start-2 cursor-pointer font-normal", labelClassName)}
            >
                {label}
            </Label>
            {helptext && (
                <div className="col-start-2">
                    <Helptext>{helptext}</Helptext>
                </div>
            )}
            {errorMessage && (
                <div className="col-start-2">
                    <FormErrorMessage>{errorMessage}</FormErrorMessage>
                </div>
            )}
        </div>
    );
}
